var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2181 31.7819C24.9342 31.7819 31.9999 24.7161 31.9999 16.0001C31.9999 7.28402 24.9342 0.218262 16.2181 0.218262C7.50204 0.218262 0.436279 7.28402 0.436279 16.0001C0.436279 24.7161 7.50204 31.7819 16.2181 31.7819Z",
    fill: "#251F2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67261 10.5454H26.7635",
    stroke: "#F9F8F0",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67261 16.3638H26.7635",
    stroke: "#F9F8F0",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67261 22.1821H26.7635",
    stroke: "#F9F8F0",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5362 10.1818C13.5362 11.1107 12.7833 11.8636 11.8544 11.8636C10.9256 11.8636 10.1726 11.1107 10.1726 10.1818C10.1726 9.25298 10.9256 8.5 11.8544 8.5C12.7833 8.5 13.5362 9.25298 13.5362 10.1818Z",
    fill: "#F9F8F0",
    stroke: "#F9F8F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7181 16.0002C23.7181 16.929 22.9652 17.682 22.0363 17.682C21.1075 17.682 20.3545 16.929 20.3545 16.0002C20.3545 15.0713 21.1075 14.3184 22.0363 14.3184C22.9652 14.3184 23.7181 15.0713 23.7181 16.0002Z",
    fill: "#F9F8F0",
    stroke: "#F9F8F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7181 21.818C15.7181 22.7469 14.9652 23.4999 14.0363 23.4999C13.1075 23.4999 12.3545 22.7469 12.3545 21.818C12.3545 20.8892 13.1075 20.1362 14.0363 20.1362C14.9652 20.1362 15.7181 20.8892 15.7181 21.818Z",
    fill: "#F9F8F0",
    stroke: "#F9F8F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterActive);
export default __webpack_public_path__ + "static/media/filter_active.9a6223770d97b21342eb926bbdfb8b85.svg";
export { ForwardRef as ReactComponent };